var render = function render(){
  var _vm$user, _vm$user$point, _vm$user$point$format;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-badge', {
    staticClass: "mb-12 mb-lg-20",
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("내 보유 포인트")])]), _c('v-card', _vm._b({
    attrs: {
      "flat": "",
      "rounded": "lg",
      "color": "grey-f1"
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('div', {
    staticClass: "pa-20 pa-md-30 pa-lg-40"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit line-height-1"
  }, [_vm._v(_vm._s(((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : (_vm$user$point = _vm$user.point) === null || _vm$user$point === void 0 ? void 0 : (_vm$user$point$format = _vm$user$point.format) === null || _vm$user$point$format === void 0 ? void 0 : _vm$user$point$format.call(_vm$user$point)) || 0) + "P")]), _c('v-btn', _vm._b({
    staticClass: "ml-6 ml-lg-10",
    attrs: {
      "icon": "",
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.getPoint
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('point-form', {
    on: {
      "search": function ($event) {
        return _vm.$emit('search');
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("충전하기")])];
      }
    }])
  })], 1)], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }